export const statuses = {
    'unreviewed' : 'Unreviewed',
    'in_progress' : 'In Progress',
    'completed' : 'Completed',
    'converted' : 'Converted',
    'rejected' : 'Rejected',
}
